var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-container',[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"lg":"8"}},[_c('Form')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }